module.exports = __webpack_public_path__ + "static/assets/252fa83cc860f036d30d4c0787fe4079.png";